// Network Tree Configuration Constants

export const NODE_SIZES = {
  ROOT: 70,
  STANDARD: 50,
  DEEP_LEVEL: 40,
};

export const LEVEL_THRESHOLDS = {
  DEEP_LEVEL_START: 4,
};

export const COLORS = {
  ACTIVITY: {
    HIGH: {
      background: '#10b981',
      border: '#059669',
    },
    MEDIUM: {
      background: '#f59e0b',
      border: '#d97706',
    },
    LOW: {
      background: '#ef4444',
      border: '#dc2626',
    },
  },
  TEMPORARY: {
    background: '#374151',
    border: '#9ca3af',
    highlight: {
      background: '#4b5563',
      border: '#d1d5db',
    },
  },
};

export const ACTIVITY_THRESHOLDS = {
  HIGH: 80,
  MEDIUM: 50,
};

export const RADIAL_LAYOUT = {
  INITIAL_RADIUS: 180,
  LEVEL_SPACING: 140,
};

export const TREE_LAYOUT = {
  LEVEL_HEIGHT: 200,      // Vertical space between levels
  MIN_NODE_GAP: 150,      // Minimum horizontal gap
  BOTTOM_PADDING: 100,    // Space from bottom
  TOP_PADDING: 100        // Space from top
};

export const D3_SIMULATION = {
  LINK: {
    DISTANCE: 140,
    STRENGTH: 0.2,
  },
  CHARGE: {
    STRENGTH: -30,
  },
  COLLIDE: {
    RADIUS_PADDING: 15,
    STRENGTH: 0.5,
  },
  ALPHA: 0.3,
  ALPHA_DECAY: 0.0005,
  VELOCITY_DECAY: 0.4,
  PRESTABILIZE_TICKS: 150,
};

